export default "__VITE_ASSET__0aedba57__"